import { Line } from "@react-three/drei";
import { Box } from "@react-three/flex";
import GeoFlex from "../Flexes/GeoFlex";
import ImgFlex from "../Flexes/ImgFlex";
import TxtFlex from "../Flexes/TxtFlex";

function OutlierBox({ 
  align, 
  scale, 
  handleThreshold, 
  viewport,
  txtOne
}) {

  return(
    <>
    <Box
      flexDirection='column' 
      align={align} 
      justify='space-evenly'
      width='100%'
      // height='60%'
      // wrap='wrap'
      margin={scale}
      flexGrow={scale}
    >
      <Box
        marginBottom={7 * scale}
        marginRight={scale}
      >
        <ImgFlex
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          justify='center'
          image='/pictures/Outlier_SS.PNG'
          viewport={viewport}
          txtOne={txtOne}
          // txtTwo={'Designer\n Musician\n'}
          txtColorOne='#009092'
          txtColorTwo='gold'
          textScaleFactor={1.025 * scale}
          textAlign='left'
        />
      </Box>
      <Box
        // margin={scale}
        marginLeft={7 * scale}
        // padding={scale}
      >
        <TxtFlex 
          scale={scale}
          onReflow={handleThreshold}
          align='center'
          justify='center'
          txtColorOne='white'
          txtColorTwo='white'
          textScaleFactor={scale * 0.45}
          textAlign='left'
          text={
            `
            Full stack creative data visualization app.\n 
            User can compare hate crime ratios for a given population.\n
            Spearheaded UX/UI planning and process.\n
            Handled visual aspects and interactions.\n
            Implemented OAuth for further versions.\n
            Worked closely with team building and testing server side,\n
            Handled API queries & data manipulation.\n
            
            
            3 developers 7 day sprint.`
        }
          />
        </Box>
    </Box>    
    </>
  );
};

export default OutlierBox;